import {Context, Feature} from '../../contexts/context';
import {rewardsApi} from '../api/apis';
import {useImmutableRemoteData} from './useRemoteData';

export const useReferralConfig = () => {
  const {getFeatureIfEnabled} = Context.useContainer();

  const referral = getFeatureIfEnabled(Feature.Referral);

  return useImmutableRemoteData(
    {key: 'useReferralConfig', skip: !referral},
    async () => rewardsApi.getReferralConfig().then(r => r.data),
  );
};
